//Custom components
import StatCard from '../../../UI/Card/StatCard';

const NewJobCreatedWidget = ({ count }: { count: number }) => {
  return <StatCard title='New Job Created' stat={count} />;
};

export default NewJobCreatedWidget;
